import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import NotificationCardWrapper from "../NotificationCardWrapper";
import CustomAvatar from "../../CustomAvatar";

const NotificationReply = ({ data }) => {
  const navigate = useNavigate();

  const commentLink = () => {
    var link;
    if (data.target_content_type === "table") {
      link = `/table/${data.target.pk}/comment`;
    }
    if (data.target_content_type === "topic") {
      link = `/table/${data.target.opinion.table.pk}/opinions/${data.target.opinion.pk}/topics/${data.target.pk}/comment`;
    }
    if (data.target_content_type === "converse") {
      link = `/table/${data.target.conversation.table.pk}/discussions/${data.target.conversation.pk}/topics/${data.target.pk}/comment`;
    }
    return link;
  };

  return (
    <NotificationCardWrapper
      // link={handleLink()}
      firstChild={
        <CustomAvatar
          size={48}
          src={data?.actor.avatar}
          alt={data?.actor.avatar}
          borderSize={1.5}
          link={`/profile/${data.actor.username}`}
        />
      }
      seccondChild={
        <Box sx={{ mr: "auto" }} onClick={() => navigate(commentLink())}>
          <Typography
            sx={{ display: "inline-block", fontWeight: "600", mr: "4px" }}
          >
            {data?.actor.username}
          </Typography>
          <Typography sx={{ display: "inline-flex", mr: "4px" }}>
            replied on your comment
          </Typography>
        </Box>
      }
    />
  );
};

export default NotificationReply;
